import type { Member } from '@/types/member';
import type { GenderUpdateResponse } from '@/types/api';
import { apiFetch } from './client';

export function getMembers(): Promise<Member[]> {
  return apiFetch<Member[]>('/api/members');
}

export function getMember(name: string): Promise<Member> {
  return apiFetch<Member>(`/api/member/${encodeURIComponent(name)}`);
}

export function getMyProfile(): Promise<Member> {
  return apiFetch<Member>('/api/auth/my-profile');
}

export function getGenderStats(cohort?: string): Promise<{ male: number; female: number; unknown: number }> {
  const params = cohort ? `?cohort=${encodeURIComponent(cohort)}` : '';
  return apiFetch(`/api/stats/gender${params}`);
}

export function updateGender(name: string, gender: string): Promise<GenderUpdateResponse> {
  return apiFetch<GenderUpdateResponse>('/api/gender', {
    method: 'PATCH',
    body: JSON.stringify({ name, gender }),
  });
}
